import { useLocation } from 'react-router-dom';
import { default as AccommodationsPage } from './AccommodationsPage';

export default function PublicAccommodationPage() {
  const { search } = useLocation();
  const searchParam = new URLSearchParams(search);
  const rpId = searchParam.get('rp_id');

  return <AccommodationsPage rpId={rpId ?? ''} />;
}
